import { SkillType } from '../../../skills/index';
var SkillBuilder = /** @class */ (function () {
    function SkillBuilder() {
        this.skill = {
            id: 'b00b0b0b-b0b00b0b-0b0b0b0b0-0b0b0b0',
            name: 'bob skill',
            creationDate: 1501145238000,
            lastUpdateDate: 1501145238000,
            type: SkillType.SOFT_SKILL,
            level: 1
        };
    }
    SkillBuilder.prototype.withId = function (id) {
        this.skill.id = id;
        return this;
    };
    SkillBuilder.prototype.withName = function (name) {
        this.skill.name = name;
        return this;
    };
    SkillBuilder.prototype.withSkillLevel = function (skillLevel) {
        this.skill.level = skillLevel;
        return this;
    };
    SkillBuilder.prototype.withCreationDate = function (date) {
        this.skill.creationDate = date;
        return this;
    };
    SkillBuilder.prototype.withLastUpdateDate = function (date) {
        this.skill.lastUpdateDate = date;
        return this;
    };
    SkillBuilder.prototype.withType = function (type) {
        this.skill.type = type;
        return this;
    };
    SkillBuilder.prototype.build = function () {
        return this.skill;
    };
    return SkillBuilder;
}());
export { SkillBuilder };
//# sourceMappingURL=skill.builder.js.map